// TODO: this file should be renamed!
// This route exists so that we can check stripe session id and make sure
// that we have the organization billing status anda data updated
// to check if the stripe subscription went through for example
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import z from 'zod';

import { BlymLoading } from '../../components/loading';
import { trackError } from '../../error/tracking';
import { captureException } from '../../logger/capture-exception';
import { useCheckProviderSession } from '../../services/storage';

const paramsSchema = z.object({
  orgId: z.string(),
});
const validateSearchSchema = z.object({
  // eslint-disable-next-line camelcase
  session_id: z.string().optional(),
  kind: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute('/app/check-checkout-session/$orgId')({
  validateSearch: validateSearchSchema,
  // eslint-disable-next-line no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = paramsSchema.parse(Route.useParams());
  // eslint-disable-next-line camelcase
  const { session_id: sessionId, kind, status } = validateSearchSchema.parse(Route.useSearch());

  // TanStack Query mutation for checking provider session
  const { mutateAsync: checkProviderSession } = useCheckProviderSession();

  useEffect(
    function () {
      const finalEndpoint = `/app?kind=${kind}&status=${status}${sessionId != null ? `&session_id=${sessionId}` : ''}`;
      if (sessionId == null) {
        // NOTE: we want window location so it completely refreshes, it will retrieve the updated bill
        window.location.replace(finalEndpoint);
        return;
      }

      // check if the provider session has gone through
      checkProviderSession({
        orgId,
        sessionId,
      })
        .catch(function (err) {
          // NOTE: we don't want to leave the user behind because of an error, just collect it
          captureException(
            err,
            {
              file: 'check-checkout-session.$orgId.ts',
              method: 'checkProviderSession',
              infoMessage: 'error while checking provider session',
            },
            trackError
          );
        })
        .finally(function () {
          // NOTE: we want window location so it completely refreshes, it will retrieve the updated bill
          window.location.replace(finalEndpoint);
        });
    },
    [kind, status, orgId, sessionId]
  );

  return (
    <div
      className={`pointer-events-none fixed inset-0 z-50 flex h-screen w-screen flex-col items-center justify-center bg-white transition-opacity duration-500 ease-out`}
      id="loading-screen-blym"
    >
      <BlymLoading />
    </div>
  );
}
